<template>
    <el-col >
        <el-col :span="20" :push="2">
            <div class="mt-3" style="margin-top: 20px">
                <div>
                    <span class="font-weight-bold">Job ID</span>
                </div>
                <el-input class="w-75" v-model="taskId" style="width: 70%; margin-right: 10px; " />
                <el-button class="ml-3" type="primary" @click="getData" style="font-size: 15px">Search</el-button>
            </div>
            <br />
            <div class="mt-3">
                <span class="font-weight-bold">Running Status</span>
                <el-progress :percentage="jobInfo.progress * 100" :stroke-width="20" class="w-50 d-inline-block ml-3" text-inside />
            </div>
            <br />
            <div class="mt-3">
                <span class="font-weight-bold">Job Basic Information</span>

                <el-descriptions :column="2" border labelClassName="labelClassName">
                    <el-descriptions-item label="rsID Identifier">
                        <el-tag type="success">{{ preConf.rsid }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="P-Value Identifier">
                        <el-tag color="#ff0">{{ preConf.pvalue }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="Beta Identifier">
                        <span>{{ preConf.beta }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Non Effect Allele Identifier">
                        <span>{{ preConf.nonEffectAllele }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Chromosome Identifier">
                        <span>{{ preConf.chromosome }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Effect Allele Identifier">
                        <span>{{ preConf.effectAllele }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="Genomic Position Identifier">
                        <span>{{ preConf.genomicPosition }}</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <br />

            <div class="mt-3">
                <span class="font-weight-bold">Output</span>
                <pre>{{ jobInfo.output }}</pre>
            </div>

            <div v-if="jobInfo.statisticsType == 'tissue'">
                <span class="font-weight-bold">Trait-specific Tissue Analysis</span>
                <h4 style="color: red">P-values listed here, as determined by deTS, indicate the likelihood of each tissue being causally linked to the disease; smaller p-values suggest a higher probability of causal association.</h4>
                <el-row gutter="30">
                    <el-col span="8" >
                        <el-card
                            shadow="never"
                        >
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults1"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    prop="name"
                                    label="Tissue">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                    <el-col span="8">
                        <el-card>
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults2"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    prop="name"
                                    label="Tissue">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                    <el-col span="8">
                        <el-card>
                            <el-table
                                border
                                empty-text="Empty data"
                                :data="resultInfo.tissueResults3"
                                style="width: 100%">
                                <el-table-column
                                    prop="p005"
                                    label="P < 0.05"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p005 >= 0.05">{{scope.row.p005}}</span>
                                        <span style="color: pink" v-if="scope.row.p005 < 0.05 && scope.row.p005 >= 0.005">{{scope.row.p005}}</span>
                                        <span style="color: red" v-if="scope.row.p005 < 0.005">{{scope.row.p005}}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    prop="p001"
                                    label="P < 0.01"
                                    width="180">
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.p001 >= 0.05">{{scope.row.p001}}</span>
                                        <span style="color: pink" v-if="scope.row.p001 < 0.05 && scope.row.p001 >= 0.005">{{scope.row.p001}}</span>
                                        <span style="color: red" v-if="scope.row.p001 < 0.005">{{scope.row.p001}}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    prop="name"
                                    label="Tissue">
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <br />

            <div v-if="jobInfo.statisticsType == 'twas'">
                <!-- <div > -->
                <span class="font-weight-bold">Gene Based Analysis Results</span>
                <el-button type="success" style="margin-left: 10px;" @click="handleComparision" >+ Compare to GENEasso Resource (Replication Study)</el-button>
                <h5 style="color: red; font-size: 17px;">Select 'Compare to Gene Resource (Check Replication)' to compare your results with our comprehensive database of significant genes, spanning 2491 diseases. This tool enables you to validate your findings by comparing them with historical data for the same disease, with higher replication indicating greater reliability and credibility of the calculations.</h5>

                <br />
                <br />
                <p style="text-align: center; font-size: 22px;"><b>Manhattan Plot (Users can obtain more information about the associations by hovering their mouse over the dots representing each gene)</b></p>
                <br />

                <div class="echarts-tool">
                    <div class="tool-item">
                        <div class="label">Enable Display Gene Label</div>
                        <div>
                            <el-switch v-model="showTooltip" @change="handleShowLegend" />
                        </div>
                    </div>

                </div>

                <h3>Personal: This label denotes the significant associations found in the dataset uploaded by the current user.</h3>
                <h3>Archival: This label refers to the significant associations from previously analyzed datasets available within GENEasso's resources.</h3>
                <div class="echarts-scatter">
                    <div style="width: 100%; height: 100%" ref="scatter"></div>
                </div>

                <!-- 添加Method Resources表格 -->
                <br />
                <el-card shadow="never" v-if="methodResources.length > 0">
                    <div slot="header" class="clearfix">
                        <span><b>Method Summary Report</b></span>
                    </div>
                    <el-table
                        border
                        empty-text="No method resources available"
                        :data="methodResources"
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="Method"
                            sortable>
                        </el-table-column>
                        <el-table-column
                            prop="url"
                            label="Download">
                            <template slot-scope="scope">
                                <a :href="scope.row.url" target="_blank" v-if="scope.row.url">
                                    Download
                                </a>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <br />
                <el-card
                        shadow="never"
                    >
                    <div slot="header" class="clearfix">
                        <b>Table Data</b>
                        <a :href='"/api/attachment/job/file?url=" + taskId + "/final.out"' target="_blank" style="float: right; padding: 3px 0; font-size: 16px;" type="text">Download</a>
                    </div>
                    <div>
                        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                            <el-form-item label="Gene Symbol">
                                <el-input v-model="searchForm.geneSymbol" placeholder="Input"></el-input>
                            </el-form-item>
                            <el-form-item label="Ensg">
                                <el-input v-model="searchForm.ensg" placeholder="Input"></el-input>
                            </el-form-item>
                            <el-form-item label="Method">
                                <el-input v-model="searchForm.method" placeholder="Input"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="searchResult" style="margin-left: 10px;">Search</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <br/>
                        <el-table
                            border
                            empty-text="Empty data"
                            :data="twasTableResults"
                            style="width: 100%">
                            <el-table-column
                                prop="geneSymbol"
                                sortable
                                label="Gene Symbol">
                            </el-table-column>
                            <el-table-column
                                prop="geneName"
                                sortable
                                label="Gene Fullname">
                                <template slot-scope="scope">
                                    <span >{{scope.row.geneName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="geneBioType"
                                label="Gene Biotype">
                            </el-table-column>
                            <el-table-column
                                prop="ensg"
                                sortable
                                label="Ensg">
                            </el-table-column>
                            <el-table-column
                                prop="geneSynonym"
                                sortable
                                label="Gene Synonym">
                            </el-table-column>
                            <el-table-column
                                prop="chromosome"
                                label="Chromosome">
                            </el-table-column>
                            <el-table-column
                                prop="startPos"
                                label="Start Pos">
                            </el-table-column>
                            <el-table-column
                                prop="endPos"
                                sortable
                                label="End Pos">
                            </el-table-column>
                            <el-table-column
                                prop="method"
                                sortable
                                label="Method">
                            </el-table-column>
                            <el-table-column
                                prop="pvalue"
                                sortable
                                label="P-Value">
                            </el-table-column>
                            <el-table-column
                                prop="additionalInfo"
                                label="Additional Info">
                            </el-table-column>
                        </el-table>
                        <br />
                        <el-pagination
                            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20]"
                            :page-size="pageSize" layout="total, sizes, prev, pager, next"
                            :total="resultInfo.twasResults?.length"
                        >
                        </el-pagination>
                    </el-card>
            </div>

            <br />
            <el-dialog title="Choose comparision" :visible.sync="showComparision">
                <div class="container-search row">
                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                        <div class="searchB">
                            <div class="searchSub">
                                <label>
                                    <span>Trait</span>
                                </label>
                                <t-select
                                    class="search-select"
                                    v-model="traitId"
                                    placeholder="eg: lung cancer"
                                    @search="handleGetTrait"
                                    :options="traitOption"
                                ></t-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showComparision = false">Cancel</el-button>
                    <el-button type="primary" @click="handleCompareConfirm">Confirm</el-button>
                </div>
        </el-dialog>
        </el-col>
    </el-col>
</template>

<script>

let timer = null;

const chrMap = {
    1: 248849517,
    2: 242078722,
    3: 198148238,
    4: 188147743,
    5: 181272307,
    6: 170572870,
    7: 159154430,
    8: 145066685,
    9: 138124624,
    10: 133569835,
    11: 134319564,
    12: 133235877,
    13: 114337626,
    14: 106368436,
    15: 101806887,
    16: 90095932,
    17: 83095122,
    18: 80247514,
    19: 58573575,
    20: 64304820,
    21: 46665124,
    22: 50783667,
};

const zoomOut = 500000;
let xAxisLabel = {};

const chrTotal = Object.values(chrMap).reduce(function (pre, cur, i) {
    xAxisLabel[i + 1] = pre + cur;
    return pre + cur;
}, 0);

function getDotPosX(dot) {
    let posX = xAxisLabel[dot.chr - 1] || 0;
    posX += dot.start;

    return Math.floor(posX / zoomOut);
}

let _data = [];
let echarts = null;

export default {
    name: "results",
    data() {
        return {
            taskId: this.$route.query.id || "",
            showWarningText: false,
            searchForm: {

            },
            jobInfo: {
                name: "",
                jobId: "",
                email: "",
                methods: [],
                preConf: {
                    rsid: "",
                    beta: "",
                    pvalue: "",
                    effectAllele: "",
                    nonEffectAllele: "",
                    sampleSize: "",
                    chromosome: "",
                    genomicPosition: "",
                    ancestry: "",
                    includingUkbb: "",
                    sexSpecific: "",
                    separator: "",
                    attachmentId: "",
                },
                createTime: "",
                updateTime: "",
                status: "",
                exitCode: "",
                progress: 0,
                output: "",
            },
            resultInfo: {
                resultList: [],
                tissueResults: [],
                twasResults: [

                ],
                tissueResults1: [],
                tissueResults2: [],
                tissueResults3: []
            },
            twasTableResults: [],
            methodResources: [], // 添加methodResources数组
            preConf: {},
            total: 0,
            currentPage: 1,
            pageSize: 10,
            showTooltip: true,
            showComparision: false,
            traitOption: []
        };
    },

    created() {
        this.getData();
    },

    mounted() {

    },

    methods: {
        // 获取数据
        async getData() {
            const res = await this.$ajax.get(`/job/${this.taskId}`);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.jobInfo = res.data;
            this.preConf = this.jobInfo.preConf;
            console.log(this.jobInfo)

            if (this.jobInfo.status == 4 || this.jobInfo.status == 5) {
                return;
            }

            // 状态等于xx则不轮询
            if (this.jobInfo.status == 0 || this.jobInfo.status == 1 || this.jobInfo.status == 2) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    this.getData();
                }, 1000 * 10);

                return;
            }

            const taskResult = await this.$ajax.get(`/job/${this.taskId}/result`);
            if (taskResult.code !== 200) {
                this.$message.error(taskResult.message);
                return;
            }
            this.resultInfo = taskResult.data;
            this.methodResources = taskResult.data.methodResources || []; // 获取methodResources数据

            this.searchResult()

            if (this.jobInfo.statisticsType == 'tissue') {
                this.resultInfo.tissueResults1 = []
                this.resultInfo.tissueResults2 = []
                this.resultInfo.tissueResults3 = []

                const total = this.resultInfo.tissueResults.length
                for (let i=0; i<Math.min(16, total); i++) {
                    this.resultInfo.tissueResults1.push(this.resultInfo.tissueResults[i])
                }

                if (total > 16) {
                    for (let i=16; i<Math.min(32, total); i++) {
                        this.resultInfo.tissueResults2.push(this.resultInfo.tissueResults[i])
                    }
                }

                if (total > 32) {
                    for (let i=32; i<total; i++) {
                        this.resultInfo.tissueResults3.push(this.resultInfo.tissueResults[i])
                    }
                }
            } else {
                _data = this.resultInfo.manhattanResults
                this.draw()
            }
        },

        handleShowLegend() {
            this.draw();
        },

        draw() {
            if (!echarts) {
                echarts = this.$echarts.init(this.$refs.scatter);
            }
            let dataTypeMap = {
                // Variant: [],
            };

            _data.forEach((v) => {
                v.method = v.method.slice(0, 1).toUpperCase() + v.method.slice(1);
                if (!dataTypeMap[v.method]) {
                    dataTypeMap[v.method] = [];
                }
                dataTypeMap[v.method].push({
                    name: v.method,
                    value: [getDotPosX(v), v.y],
                    _extend: v,
                });
            });

            const dataTypeMapKeyArr = Object.keys(dataTypeMap);
            const data = dataTypeMapKeyArr.map((key) => {
                return {
                    name: key,
                    type: "scatter",
                    // symbol: (key === "Gene" && "rect") || null,
                    // 圆的大小
                    symbolSize: 7,
                    // 圆的标签
                    label: {
                        show: this.showTooltip,
                        position: "top",
                        formatter: function (params) {
                            const data = params.data._extend;
                            return data.name;
                        },
                    },
                    data: dataTypeMap[key],
                };
            });

            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3ba272",
                    "#fc8452",
                    "#9a60b4",
                    "#ea7ccc",
                    "#4962FC",
                    "#4B7CF3",
                    "#dd3ee5",
                    "#12e78c",
                    "#fe8104",
                    "#01C2F9",
                    "#F4CB29",
                    "#FD9E06",
                ],
                grid: {
                    top: 100,
                    right: 50,
                },
                legend: {
                    show: true,
                    // data: dataTypeMapKeyArr,
                    data: Object.keys(dataTypeMap),
                    top: 5,
                    left: "10%",
                    textStyle: {
                        fontSize: 20,
                    },
                },
                tooltip: {
                    show: true,
                    formatter: function (params) {
                        // params.value[0]  x轴 数据
                        // params.value[1]  y轴 数据

                        const results = [];

                        const _extend = params.data._extend;
                        if (_extend.description) {
                            const lines = _extend.description.split("\n");
                            lines.forEach((it) => {
                                const splits = it.split(";");
                                splits.forEach((split) => {
                                    results.push(split);
                                });
                            });
                        }

                        return results.join("<br />");
                    },
                },
                xAxis: {
                    show: true,
                    name: "Genomic Position(number denotes chromosome)",
                    nameGap: 25,
                    nameLocation: "center",
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    minInterval: 1,
                    // maxInterval: 1,
                    max: Math.floor((chrTotal + zoomOut) / zoomOut),
                    min: 1,
                    interval: 1,
                    axisLabel: {
                        show: true,
                        formatter: (value) => {
                            let i = Object.values(xAxisLabel)
                                .map((v, _i) => v - chrMap[_i + 1] / 2)
                                .map((v) => Math.floor(v / zoomOut))
                                .indexOf(value);
                            return i + 1 || "";
                        },
                    },
                    splitNumber: 0,
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                yAxis: {
                    show: true,
                    name: "-log10 P-value",
                    nameGap: 30,
                    max: 50,
                    nameLocation: "center",
                    nameTextStyle: {
                        fontSize: 15,
                    },
                },
                series: data,
            };

            echarts.setOption(option);
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.currentPage = 1;
            this.pageSize = val;
            this.searchResult()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.searchResult()
        },

        handleShowWarningText() {
            this.showWarningText = !this.showWarningText;
        },

        handleComparision() {
            this.showComparision = true;
        },

        // Trait
        async handleGetTrait(value) {
            const params = {
                keyword: value,
                pageSize: 20,
            };
            let res = await this.$ajax.get("trait/search/page", params);
            const data = res.data.records || [];
            this.traitOption = data.map((v) => {
                return {
                    // 用于显示的名称
                    label: v.efoOntologyTrait,
                    value: v.id,
                };
            });
        },

        searchResult() {
            console.log('search result...', this.resultInfo.twasResults)
            if (!this.resultInfo.twasResults) {
                return
            }
            // this.resultInfo.twasResults = [{method: '1111', 'geneSymbol': 'AA'},
            //         {method: '2222', 'geneSymbol': 'BB'}]
            let data = this.resultInfo.twasResults

            data = data.filter(item => {
                const {geneSymbol, method, ensg} = this.searchForm;
                if (geneSymbol) {
                    if (item.geneSymbol.indexOf(geneSymbol) < 0) {
                        return false;
                    }
                }
                if (ensg) {
                    if (item.ensg.indexOf(ensg) < 0) {
                        return false;
                    }
                }
                if (method) {
                    if (item.method.indexOf(method) < 0) {
                        return false;
                    }
                }
                return true;
            })
            this.twasTableResults = data.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
        },

        handleCompareConfirm() {
            this.showComparision = false;
            this.$router.push({
                path: '/compare',
                query: {
                    jobId: this.taskId,
                    traitId: this.traitId
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.font-weight-bold {
    font-size: 20px;
    font-weight: bold;
}
/deep/ .el-form-item {
    margin: 0;


}

/deep/.el-form-item__label {
        padding: 0px;
        margin-left: 10px;
        margin-right: 10px;
        font-size: 16px;
    }

pre {
    background: #606266;
    width: 75%;
    height: 250px;
    overflow: auto;
    color: #ffffff;
    border-radius: 8px;
    padding: 10px 15px;
}


.echarts-scatter {
    width: 100%;
    height: 800px;
}

.echarts-tool {
    display: flex;
    margin: 10px 0 15px;
    justify-content: center;

    .tool-item {
        display: flex;
        align-items: center;
        margin-right: 15px;
    }

    .label {
        font-weight: normal;
        font-size: 18px;
        color: #333333;
        padding: 0;
        margin: 0 5px 0 0;
    }
}

/deep/ .labelClassName {
    width: 200px;
}
</style>
